angular.module('impactx.sidebar').directive('ixSideBarSubMenu', [function() {
    return {
        scope: {
            menuitem: "="
        },
        controller: 'SideBarSubMenuCtrl',
        controllerAs: 'sideBarMenuItemCtrl',
        restrict: 'E',
        templateUrl: 'shared/sidebar/templates/sidebar-submenu.tmpl.html'
    }
}]);